import {ERROR_WAIT_BLOCK, STEP_WAIT_BLOCK} from "../../AdminProtectora/actions/actionsAdmin";

export const CHANGE_TIPO = 'CHANGE_TIPO';
export const CHANGE_NOMBRE = 'CHANGE_NOMBRE';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const CHANGE_ASUNTO = 'CHANGE_ASUNTO';
export const CHANGE_MENSAJE = 'CHANGE_MENSAJE';
export const INIT = 'INIT';
export const SEND_EMAIL = 'SEND_EMAIL';
export const ERROR_SEND_EMAIL = 'ERROR_SEND_EMAIL';
export const RESET_CONTACT_BY_EMAIL = 'RESET_CONTACT_BY_EMAIL';


export function changeTipo(tipo) {
    return (dispatch, getState) => {
        dispatch({type: CHANGE_TIPO, payload: {tipo: tipo}});
    }
}

export function changeNombre(nombre) {
    return (dispatch, getState) => {
        dispatch({type: CHANGE_NOMBRE, payload: {nombre: nombre}});
    }
}


export function changeEmail(email) {
    return (dispatch, getState) => {
        dispatch({type: CHANGE_EMAIL, payload: {email: email}});
    }
}


export function changeAsunto(asunto) {
    return (dispatch, getState) => {
        dispatch({type: CHANGE_ASUNTO, payload: {asunto: asunto}});
    }
}

export function changeMensaje(mensaje) {
    return (dispatch, getState) => {
        dispatch({type: CHANGE_MENSAJE, payload: {mensaje: mensaje}});
    }
}

export function init() {
    return (dispatch, getState) => {
        dispatch({type: INIT, payload: {}});
    }
}

export function resetContactByEmail() {
    return (dispatch, getState) => {
        dispatch({type: RESET_CONTACT_BY_EMAIL, payload: {}});
    }
}

export function sendEmail(idProtectora, idAnimal) {
    return (dispatch, getState) => {
        //console.log("actionsContactByEmail::onSendEmail()");
        let contactData = getState().contactByEmail;
        // let animalDetail = getState().infoAnimalDetail;
        let animalDetail = (idAnimal) ? {id: idAnimal} : getState().infoAnimalDetail;
        let protectoraDetail = (idProtectora) ? {_id: idProtectora} : getState().animalDetail.infoProtectoraDetail;
        let datos = {
            "fromEmail": contactData.email,
            "fromNombre": contactData.nombre,
            "protectora": protectoraDetail._id,
            "animal": animalDetail.id,
            "texto": contactData.mensaje
        };

        if (contactData.tipo === "animal") {
            datos.tipoEmail = "paraProtectora_interes_por_animal";
        } else if (contactData.tipo === "protectora") {
            datos.tipoEmail = "paraProtectora_peticion_info_de_protectora";
        }


        $.ajax({
            type: "POST",
            data: JSON.stringify(datos),
            dataType: "json",
            contentType: "application/json",
            url: "/api/utils/enviarEmail",
        })
            .done(function (response, textStatus, jqXHR) {
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});
                dispatch({type: SEND_EMAIL, payload: response});

            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log) {
                    //console.log("La solicitud a fallado: " + errorStr);
                }
                dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: jqXHR.status}});

            });
    }
}


export function newSendEmail(info) {
    return (dispatch, getState) => {
        let datos = {
            "fromEmail": info.email,
            "fromNombre": info.nombre,
            "texto": info.mensaje,
            "protectora": info.idProtectora,
            "animal": info.idAnimal,
            ...info
        };

        if (info.tipo === "animal") {
            datos.tipoEmail = "paraProtectora_interes_por_animal";
        } else if (info.tipo === "protectora") {
            datos.tipoEmail = "paraProtectora_peticion_info_de_protectora";
        } else if (info.tipo === "EntityProtectora") {
            datos.tipoEmail = "paraEntityProtectora_peticion_info";
        }


        $.ajax({
            type: "POST",
            data: JSON.stringify(datos),
            dataType: "json",
            contentType: "application/json",
            url: "/api/utils/enviarEmail",
        })
            .done(function (response, textStatus, jqXHR) {
                //console.log("newSendEmail::newSendEmail() -> done");
                dispatch({type: SEND_EMAIL, payload: response});
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                //console.log("newSendEmail::newSendEmail() -> fail");

                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON;
                }

                if (console && console.log) {
                    //console.log("La solicitud a fallado: " + errorStr);
                }
                dispatch({type: ERROR_SEND_EMAIL, payload: {errorSendEmail: errorStr}});
            });
    }
}


export function sendContactEmail(data, infoAdminProtectora) {
    return (dispatch) => {
        //console.log("actionsContactByEmail::sendContactEmail()");

        let datos = {
            "fromEmail": (infoAdminProtectora && infoAdminProtectora.isLogin && infoAdminProtectora.user) ? infoAdminProtectora.user : data.email,
            "fromNombre": data.name,
            "texto": data.content
        };

        if (infoAdminProtectora && infoAdminProtectora.isLogin && infoAdminProtectora.id) {
            datos.tipoEmail = "paraSoporte_contacta_con_nosotros_protectoras",
                datos.protectora = infoAdminProtectora.id
        } else {
            datos.tipoEmail = "paraSoporte_contacta_con_nosotros_usuarios"
        }

        $.ajax({
            type: "POST",
            data: JSON.stringify(datos),
            dataType: "json",
            contentType: "application/json",
            url: "/api/utils/enviarEmail",
        })
            .done(() => {
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: 201}});
            })
            .fail((jqXHR, textStatus, _errorThrown) => {
                let errorStr;
                if (typeof jqXHR.responseJSON === "object" && jqXHR.responseJSON.error !== undefined) {
                    errorStr = jqXHR.responseJSON.error.map(err => err.msg).join(', ').replace(/,(?!.*,)/gmi, ' y')
                } else {
                    errorStr = jqXHR.responseJSON ? jqXHR.responseJSON : "Hubo un error inesperado al enviar el email :(";
                }

                if (console && console.log) {
                    //console.log("La solicitud a fallado: " + errorStr);
                }
                dispatch({type: ERROR_WAIT_BLOCK, payload: {errorWaitBlock: errorStr}});
                dispatch({type: STEP_WAIT_BLOCK, payload: {stepWaitBlock: jqXHR.status}});
            });
    }
}


